import React from "react";
import { Link } from "react-router-dom";
import { Tag } from "primereact/tag";

import { ProspectType } from "../../../../types/onboarding";
import { isAdditionalStation } from "../../../../utils/prospectType";

interface ProspectTypeTagProps {
  prospect: {
    prospect_type?: ProspectType | null;
    existing_customer_prospect_id?: string | null;
  };
  /** The detail page also links to the existing customer's onboarding. */
  linkToExistingCustomer?: boolean;
}

/**
 * CWA-184: an existing owner adding a station (CWA-179). Promoting it assigns the stations to their existing
 * clearing customer (CWA-182), and its contact and bank details were copied from that customer (CWA-180).
 */
const ProspectTypeTag = ({ prospect, linkToExistingCustomer = false }: ProspectTypeTagProps) => {
  if (!isAdditionalStation(prospect)) return null;
  const existingId = prospect.existing_customer_prospect_id;

  return (
    <>
      <Tag
        icon="pi pi-plus-circle"
        value="Additional station"
        title="An existing customer adding a station"
      />
      {linkToExistingCustomer &&
        (existingId ? (
          <Link to={`/onboarding/prospects/${existingId}`} className="text-sm">
            Existing customer's onboarding
          </Link>
        ) : (
          <span className="text-500 text-sm">Owner from before self-service onboarding</span>
        ))}
    </>
  );
};

export default ProspectTypeTag;
